import Vue from 'vue'
export default Vue.extend({
  data () {
    return {
      platform: '',
      appLink: '',
      storeLink: ''
    }
  },
  created () {
    // vue router에 url이라는 쿼리 스트링이 있으면 바인딩되며 appLink watch에서 감지해서 페이지 전환이 일어남
    this.detailUrl = this.$route.query.url
    this.checkMobile()
  },
  methods: {
    checkMobile () {
      const agent = navigator.userAgent.toLowerCase()
      if (agent.indexOf('android') > -1) {
        this.platform = 'android'
        this.appLink = `intent://data?url=${this.detailUrl}#Intent;scheme=modnpayorder;package=info.seeroo.modnpayorder;end`
        this.storeLink = 'https://play.google.com/store/apps/details?id=info.seeroo.onuriorder&hl=ko'
      } else if (agent.indexOf('iphone') > -1 || agent.indexOf('ipad') > -1 || agent.indexOf('ipod') > -1) {
        this.platform = 'iOS'
        this.appLink = `modnpayorder://data?url=${this.detailUrl}`
        this.storeLink = 'https://apps.apple.com/kr/app/id6740787331'
      } else {
        this.platform = 'other'
      }
    },
    callApp () {
      window.location.href = this.storeLink
    }
  },
  watch: {
    appLink () {
      if (this.detailUrl) {
        window.location.href = this.appLink
      }
    }
  }

})
